import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles/ExpandingContent.scss';
import ArrowDown from 'dibs-icons/exports/ArrowDown';
import ArrowUp from 'dibs-icons/exports/ArrowUp';

export class ExpandingContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isExpanded: props.startExpanded,
            collapsedHeight: null,
        };
        this.onToggleExpanded = this.onToggleExpanded.bind(this);
        this.ref = React.createRef();
    }
    componentDidMount() {
        // we're chopping up cms content which has html tags which react-dom/server can't handle
        this.setState({ isExpanded: false }, () => {
            this.setState({ collapsedHeight: this.ref.current.clientHeight });
        });
    }
    onToggleExpanded(e) {
        e.preventDefault();
        // logic for smooth height animation on mobile
        // you can't do a css animation for height: auto
        if (this.state.isExpanded) {
            // when collapsing set the height to current element height (large size)
            this.ref.current.style.height = this.ref.current.clientHeight + 'px';
            requestAnimationFrame(() => {
                // set the height to the stored collapsed height (small size)
                // them update the content
                this.ref.current.style.height = this.state.collapsedHeight + 'px';
                const stateChange = () => {
                    this.setState({ isExpanded: false });
                    this.ref.current.removeEventListener('transitionend', stateChange);
                };
                this.ref.current.addEventListener('transitionend', stateChange);
            });
        } else {
            // when collapsing set the height to current element height (small size)
            this.ref.current.style.height = this.ref.current.clientHeight + 'px';
            this.setState({ isExpanded: true }, () =>
                // after content has been expanded. set the height to current
                // inner content height (scrollHeight, large size)
                requestAnimationFrame(
                    () => (this.ref.current.style.height = this.ref.current.scrollHeight + 'px')
                )
            );
        }
    }
    render() {
        const { isExpanded } = this.state;
        let icon = <ArrowDown className={styles.expandIcon} />;
        if (isExpanded) {
            icon = <ArrowUp className={styles.expandIcon} />;
        }

        // two callbacks so controls can be outside of expanding content
        const expandingContent = (
            <div ref={this.ref} className={styles.container}>
                {this.props.expandingChildren({
                    isExpanded,
                    icon,
                    onToggleExpanded: this.onToggleExpanded,
                })}
            </div>
        );
        return this.props.children({
            isExpanded,
            icon,
            expandingContent,
            onToggleExpanded: this.onToggleExpanded,
        });
    }
}

ExpandingContent.propTypes = {
    startExpanded: PropTypes.bool,
    expandingChildren: PropTypes.func.isRequired,
    children: PropTypes.func.isRequired,
};

ExpandingContent.defaultProps = {
    startExpanded: false,
};
